/* @flow */

import React, { Component } from "react";

import { View, Image, Text, Pressable, ScrollView } from "react-native";

//Modules
import Match from "../../screens/match.js";
import Scores from "../../components/widgets/scores.js";

//
import GLOBAL from "../../helpers/global.js";
import MainStyles from "../../helpers/mainstyles.js";
import Functions from "../../helpers/functions.js";

export default class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      wsc: this.props.wsc,
    };
    this.iframeRef = React.createRef();
    this.player = null;
  }

  componentDidUpdate = async (prevProps) => {
    // alert('vid')
    // console.log(prevProps.id, this.props.id)
    if (prevProps.id !== this.props.id) {
      var id = this.props.id;
      // var url = "https://www.youtube.com/embed/uFAPjQy40JQ?autoplay=1"

      // "https://www.youtube.com/watch?v=0ccfcGVP3ko"

      var id_youtube = id ? id.split("?v=")[1] : "";
      var url =
        "https://www.youtube.com/embed/" +
        id_youtube +
        "?autoplay=1&enablejsapi=1";

      await this.setState({ id: this.props.id, wsc: this.props.wsc, url });
    }
  };

  hide_overlay = () => {
    this.setState({ id: null });
    this.props.clearVideo();
  };

  playStory = () => {
    if (!GLOBAL.playWSCStory) return;
    //Pause the current video
    this.iframeRef.current.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: "pauseVideo",
        args: [],
      }),
      "*"
    );

    //Play WSC
    GLOBAL.playWSCStory(this.state.wsc);
  };

  renderOverlay = () => {
    var { id, wsc, url } = this.state;
    if (id) {
      var padding = GLOBAL.padding;
      var width = GLOBAL.displayMode === "mobile" ? "100%" : "75%";
      var size = 36;
      return (
        <View style={{position:'absolute', height:'100%', width:'100%'}}>
          {/* {<View style={{ width: "100%" }}>
            <Scores />
          </View>} */}
          <Pressable
            onPress={this.hide_overlay}
            style={[
              {
                width: "100%",
                flex: 1,
                // position: "absolute",
                // width: "100%",
                // height: "100%",
                backgroundColor: "rgba(0,0,0,0.8)",
                // padding,
              },
              MainStyles.flexCenter,
            ]}
          >
            <View
              style={[
                {
                  width: width,
                  aspectRatio: 1920 / 1080,
                  backgroundColor: "transparent",
                  borderRadius: 0,
                },
                MainStyles.flexCenter,
              ]}
            >
              <View
                style={[
                  { width: "100%", height: "100%" },
                  MainStyles.flexCenter,
                ]}
              >
                <iframe
                  ref={this.iframeRef}
                  width={"100%"}
                  height={"100%"}
                  src={url}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; full-screen"
                  allowfullscreen="1"
                  autoplay="1"
                ></iframe>
              </View>
            </View>
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                marginTop: GLOBAL.padding * 2,
              }}
            >
              <Pressable
                onPress={this.hide_overlay}
                style={[
                  {
                    backgroundColor: "#4A4E53",
                    height: 48,
                    paddingHorizontal: GLOBAL.padding,
                    borderRadius: GLOBAL.borderRadius,
                  },
                  MainStyles.flexCenter,
                ]}
              >
                <Text
                  style={{
                    fontFamily: GLOBAL.fonts.bold,
                    fontSize: 14,
                    color: "white",
                    textTransform: "uppercase",
                  }}
                >
                  Close player
                </Text>
              </Pressable>
              {wsc && GLOBAL.playWSCStory && (
                <Pressable
                  onPress={this.playStory}
                  style={[
                    {
                      backgroundColor:
                        GLOBAL.style.cta?.backgroundColor || "#4A4E53",
                      height: 48,
                      paddingHorizontal: GLOBAL.padding,
                      borderRadius: GLOBAL.borderRadius,
                      marginLeft: 16,
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    },
                    MainStyles.flexCenter,
                  ]}
                >
                  <Text
                    style={{
                      fontFamily: GLOBAL.fonts.bold,
                      fontSize: 14,
                      color: GLOBAL.style.cta.color,
                      textTransform: "uppercase",
                    }}
                  >
                    View Match Story
                  </Text>
                  <Image
                    style={{
                      height: 14,
                      width: 14,
                      marginTop: 1,
                      resizeMode: "contain",
                      marginLeft: 8,
                      tintColor: GLOBAL.style.cta.color,
                    }}
                    source={require("../../assets/icons/play.png")}
                  />
                </Pressable>
              )}
            </View>
          </Pressable>
        </View>
      );
    } else {
      return null;
    }
  };

  render = () => {
    try {
      return this.renderOverlay();
    } catch (e) {
      console.error(e);
      return null;
    }
  };
}
